<template>
  <div class="version">
    <h2>请选择线上版本</h2>
    <p>更换版本会对用户造成无法预估的风险，请谨慎操作</p>
    <p>
      <bk-selector class="selector" 
      :list="list"
      :selected.sync="defaultDemo.selected"
      :setting-key = "'version_id'"
      :displayKey ="'name'"
      @item-selected="selected">
      </bk-selector>
    </p>
    <p class="form-action">
      <a class="bk-button bk-primary" @click="sendVersionId" title="确定">
        <span>确定</span>
      </a>
      <a class="bk-button" title="取消" @click="cancel">
        <span>取消</span>
      </a>
    </p>
  </div>

</template>

<script type="text/javascript">
  import bkSelector from '../../../components/selector/selector.vue'
  export default {
    props: {  
      //版本号的列表
      versionList: {
        type: Array
      }
    }, 
    components: {
      bkSelector
    },
    data () {
      return {
        list: [],
        defaultDemo: {
          selected: 0
        },
        version_id: '',
       
      }
    },
    methods: {
      selected (item,data) {
        this.showIcon = data.name;
        console.log(item+"123");
        this.version_id = item;
      },
      cancel () {
        this.$emit('close')
      },
      sendVersionId(item) {
       
      
        this.$emit('changeVersion',this.version_id );
        this.cancel();
      }
    },
    mounted() {
      this.list = this.versionList
    }
  }
</script>

<style media="screen" lang="scss" scoped>
  .version {    
    padding: 0 40px 20px 40px;
    font-size: 14px;
    color: #737987;
    line-height: 24px;
    .selector {
      margin: 20px 0 30px 0;
    }
    h2 {
      font-size: 22px;
      color: #212232;
      text-align: center;
      line-height: 30px;
      padding: 0 0 20px 0;
    }
    .form-control {
      -webkit-appearance: none;
      appearance: none;
      padding: 0 12px;
      margin: 20px 0 30px;
      height: 38px;
      line-height: 36px;
      box-shadow: none;
      border-radius: 2px;
      background: url(../../../images/common/select.png) 260px center no-repeat;
    }
    .form-action {
      text-align: center;
      .bk-button {
        width: 110px !important;
        float: none;
        margin-right: 10px;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// change_version.vue?af6c4c36